module.exports = __webpack_public_path__ + "static/media/13.4b3ae523.jpg";